import classNames from "classnames";

import AscTextInput from "../../../../AscInputFields/AscTextInput/AscTextInput";
import AscRichTextEditor from "../../../../AscRichTextEditor/AscRichTextEditor";
import AscHeading from "../../../../AscTypography/AscHeading/AscHeading";
import AscParagraph from "../../../../AscTypography/AscParagraph/AscParagraph";

import styles from "./AscActivityEssay.module.scss";
import { useAscAddModuleActivitiesForm } from "../../useAscAddModuleActivitiesForm";

export default function AscActivityEssay() {
  const formik = useAscAddModuleActivitiesForm();

  return (
    <div className={styles.ground}>
      <AscHeading className={styles.header} level={6}>
        Topic
      </AscHeading>

      <div className={styles.fieldForm}>
        <label className={styles.fieldLabel} htmlFor="essay.questions.name">
          Name of topic
        </label>
        <AscTextInput
          className={classNames(styles.inputField, {
            [styles.errorInput]: formik.errors?.essay && formik.touched?.essay,
          })}
          fullWidth={true}
          placeholder="Name of topic"
          id="essay.questions.name"
          name="essay.questions.name"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik?.values?.essay?.questions?.name}
        />
        {formik?.errors?.essay && formik.touched?.essay ? (
          <div className={styles.fieldError}>
            {formik.errors?.essay?.toString()}
          </div>
        ) : null}
      </div>

      <AscParagraph className={styles.title}>Placeholder</AscParagraph>

      <div className={styles.textEditorGround}>
        <AscRichTextEditor
          editable={true}
          initialInferValue={formik?.values?.essay?.questions?.description}
          onHtmlChange={(val) =>
            formik.setFieldValue("essay.questions.description", val)
          }
        />
      </div>
    </div>
  );
}
